import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <div className="page-title-box d-flex align-items-center justify-content-between flex-wrap gap-2 mt-2">
      <h4 className="mb-0 font-size-18 text-truncate">
        {props.breadcrumbItem}
      </h4>
      <div className="page-title-right flex-shrink-0">
        <ol className="breadcrumb m-0">
          <BreadcrumbItem>
            <Link to="#">{props.title}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>
            <Link to="#">{props.breadcrumbItem}</Link>
          </BreadcrumbItem>
        </ol>
      </div>
    </div>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default Breadcrumb
